import type {ColumnConfig} from 'schema/table/types';
import {workDefaultColumns} from './workDefaultColumns';

export const workSummaryDefaultColumns: ColumnConfig[] = [
  {
    name: 'mainTitles',
    width: 150,
  },
  ...workDefaultColumns,
  {
    name: 'otherTitleType36',
    width: 150,
  },
  {
    name: 'otherTitleType37',
    width: 150,
  },
];
